/**
 * Section header that goes at the top of the content view
 * Behind the scenes uses SectionHeaderCollectionView, which
 * shows and hides correct header based on active section.
 * Configures collection of sections from form.
 */
define('formkit/view/block/answer.section.header.view',['require','exports','module','../form/section/section.header.collection.view','../form/section/section.header.item.answer.view'],function(require, exports, module) {
  var SectionHeaderCollectionView = require('../form/section/section.header.collection.view');
  var SectionHeaderItemAnswerView = require('../form/section/section.header.item.answer.view');

  var SectionHeaderBlockView = SectionHeaderCollectionView.extend({

    childView: SectionHeaderItemAnswerView,

    initialize: function() {
      SectionHeaderCollectionView.prototype.initialize.apply(this, arguments);

      // figure out collection from form
      if (this.form) {
        this.collection = this.form.getTemplateModel().get('children');
      }
    }
  });

  module.exports = SectionHeaderBlockView;
});

